import { clinicErrorsAdapter, ErrorsPage, parseErrorsSearch, type ErrorsSearch } from '@pa/staff'
import { createFileRoute } from '@tanstack/react-router'
import { useMemo } from 'react'

/**
 * C-03 Errors and the C-03a drawer (`error`), with the filters and page in the URL (Frontend §6.1). Shared feature
 * (`@pa/staff` `errors`, Frontend §5.4) over the clinic adapter (#20–#22). Times and presets in the clinic's zone.
 */
export const Route = createFileRoute('/_authed/clinics/$clinicId/errors')({
  validateSearch: (raw: Record<string, unknown>): ErrorsSearch => parseErrorsSearch(raw),
  component: function ErrorsRoute() {
    const { clinicId } = Route.useParams()
    const { timeZone } = Route.useRouteContext()
    const search = Route.useSearch()
    const navigate = Route.useNavigate()
    const adapter = useMemo(() => clinicErrorsAdapter(clinicId), [clinicId])
    return (
      <ErrorsPage
        adapter={adapter}
        timeZone={timeZone}
        search={search}
        onSearch={(next, opts) => {
          void navigate({ search: next, replace: opts?.replace ?? false })
        }}
      />
    )
  },
})
